// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1PN1X","notes":"Notes_notes__1VcLk","note":"Notes_note__1YS7R","markdown":"Notes_markdown__1DTX5"};